import { render, staticRenderFns } from "./FenleiBianji.vue?vue&type=template&id=c96dd45a&"
import script from "./FenleiBianji.vue?vue&type=script&lang=js&"
export * from "./FenleiBianji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FenleiBianji.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=Yangshi.css"
if (typeof block0 === 'function') block0(component)

export default component.exports